import React from "react"
import strings from "../../localization/strings"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import AppStateStore from "../../stores/AppStateStore"

const AccountRegistrationInfo: React.SFC<null> = () => {
    document.title = `Register Completed | ${strings.Findd_Grandd_Central}`
    return (
        <RegistrationLayout
            leftContainer={
                <div style={{ textAlign: "center" }}>
                    <h1>Check your email</h1>
                    <h2 style={{ fontWeight: "normal" }}>We've sent an email to <b>{AppStateStore.registrationEmail}</b></h2>
                    <h4 style={{ fontWeight: "normal" }}>Click the link in the email to confirm your address and activate your account.</h4>
                    <h4 style={{ fontWeight: "normal" }}>Didn't get the email? <b>Check your spam folder</b></h4>
                    <a href="/login" style={{ color: "rgba(0,0,0,0.4)" }}>Go To Login</a>
                </div>
            }
            rightContainer={
                <div style={{ color: "white", padding: 50, paddingTop: 200 }}>
                    <img src="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/email-graphic.png" style={{ maxWidth: 350 }} />
                </div>
            }
            loading={null}
            frontEndSettings={AppStateStore.getFrontEndSettings()}
        />
    )
}

export default AccountRegistrationInfo